export default {
  name: 'Dashboard',
  methods: {
    formatLocaleHour (date) {
      var event = new Date(date)
      return event.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
    },
    formatLocaleHourChart (date) {
      var event = new Date(date)
      return event.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', month: 'numeric', day: '2-digit'})
    },
    formatLocaleDate (date) {
      var event = new Date(date)
      return event.toLocaleDateString()
    },
    formatDate (date) { // fecha separada por '-'
      var d = new Date(date)
      let month = '' + (d.getMonth() + 1)
      let day = '' + d.getDate()
      let year = d.getFullYear()
      if (month.length < 2) {
        month = '0' + month
      }
      if (day.length < 2) {
        day = '0' + day
      }
      return [year, month, day].join('-')
    },
    formatLocaleNumber (n) {
      return n.toLocaleString(undefined, { maximumFractionDigits: 2 })
    },
    compareDate (date) {
      var today = new Date()
      var event = new Date(date)
      today.setHours(0, 0, 0, 0)
      event.setHours(0, 0, 0, 0)
      if (today === event) {
        return true
      } else {
        return false
      }
    },
    // Función para setear los iconos de las tablas
    mapModuleClmIcon (moduleClm) {
      var icon = ''
      switch (moduleClm.toLowerCase()) {
        case 'environment':
        case 'medioambiente':
          icon = 'ods-icon-icon_environment_isolated'
          break
        case 'mobilityandtransportation':
        case 'mobility':
        case 'movilidad':
          icon = 'ods-icon-icon_mobility_isolated'
          break
        case 'parksandgarderns':
        case 'parksandgardens':
        case 'parques':
          icon = 'ods-icon-icon_parks_isolated'
          break
        case 'ilumination':
        case 'iluminacion':
          icon = 'ods-icon-icon_energy_isolated'
          break
        case 'security':
        case 'emergencias':
          icon = 'ods-icon-icon_emergency_isolated'
          break
        case 'urbanism':
        case 'urbanismo':
          icon = 'ods-icon-icon_urbanism_isolated'
          break
        case 'waste':
        case 'limpieza':
          icon = 'ods-icon-icon_waste_isolated'
          break
        case 'crm':
          icon = 'ods-icon-icon_iniciatives'
          // icon = 'ods-icon-bullhorn'
          break
        case 'fleet':
          icon = 'ods-icon-icon_floats_isolated'
          break
      }
      return icon
    },
    setAlert (alert, index) {
      const mv = this
      return {
        id: alert.id,
        level: alert.severity.substring(2),
        severity: alert.severity,
        icon: mv.mapModuleClmIcon(alert.clmModule),
        clmmodule: alert.clmModule,
        type: alert.type,
        date: alert.timestamp,
        name: alert.name,
        description: alert.description,
        responsable: alert.responsable,
        state: alert.state,
        geometry: {
          coordinates: [
            alert.geometry.coordinates[0],
            alert.geometry.coordinates[1]
          ]
        }
      }
    },
    setCampaign (campaign, index) {
      const mv = this
      return {
        id: campaign.id,
        level: campaign.currentLevel.replace(/\D/g, ''),
        state: campaign.state,
        icon: mv.mapModuleClmIcon(campaign.clmModule),
        clmmodule: campaign.clmModule,
        type: campaign.type ? campaign.type : 'campaign',
        name: campaign.name,
        description: campaign.description,
        startDate: mv.formatLocaleDate(campaign.startDate),
        endDate: mv.formatLocaleDate(campaign.endDate),
        period: mv.formatLocaleDate(campaign.startDate) + ' - ' + mv.formatLocaleDate(campaign.endDate),
        levelProcedure: campaign.level
      }
    },
    setSocialItem (socialItem, index) {
      const mv = this
      let date = ''
      if (mv.compareDate(socialItem.date)) {
        date = mv.$t('today') + ' - ' + mv.formatLocaleDate(socialItem.date)
      } else {
        date = mv.formatLocaleDate(socialItem.date) + ' - ' + mv.formatLocaleHour(socialItem.date)
      }
      return {
        id: socialItem.id,
        userName: socialItem.userName,
        userPicture: socialItem.userPicture || null,
        date: date,
        comment: socialItem.comment,
        picture: socialItem.picture,
        sentiment: socialItem.sentiment,
        socialNetwork: socialItem.socialNetwork
      }
    },
    setKpi (kpi, index) {
      const mv = this
      if (kpi.calculationMethod === 'min') {
        kpi.calculationMethod = 'minimo'
      } else {
        kpi.calculationMethod = 'maximo'
      }
      return {
        measureType: kpi.measureType,
        calculationMethod: kpi.calculationMethod,
        title: mv.$t(kpi.measureType),
        name: kpi.calculationMethod,
        value: Number(kpi.kpiValue) || 0,
        trend: kpi.kpiTrend === 'UP' ? 1 : (kpi.kpiTrend === 'DOWN' ? -1 : null),
        kpiUnit: kpi.kpiUnit
      }
    },
    mapList (listData, type) {
      const mv = this
      let list = []
      var row = []
      var contKpi = 0
      if (listData.length > 0 || listData.aeroAllergenKpi || listData.weatherKpi) {
        if (type === 'environment' || type === 'parksAndGarderns' || type === 'all') {
          list = listData
        } else {
          if (type === 'kpis') {
            // listData = mv.sortKpis(listData)
          }
          listData.map((element, index) => {
            if (type === 'alert') list.push(mv.setAlert(element, index))
            if (type === 'campaign') list.push(mv.setCampaign(element, index))
            if (type === 'social') {
              if (element !== null) list.push(mv.setSocialItem(element, index))
            }
            if (type === 'kpis') {
              if (contKpi < 2) {
                row.push(mv.setKpi(element, index))
                contKpi++
              } else {
                list.push([...row])
                contKpi = 1
                row = []
                row.push(mv.setKpi(element, index))
              }
              if (index === listData.length - 1) {
                list.push([...row])
              }
            }
          })
        }
      }
      /*
      if (type === 'kpis') {
        listData.sort(function (a, b) {
          if (a.kpiUnit > b.kpiUnit) {
            return 1
          }
          if (a.kpiUnit < b.kpiUnit) {
            return -1
          }
          // a must be equal to b
          return 0
        })
      }
      */
      return list
    },
    mapFilterList (listData, filter, field) {
      var list = []
      list = listData.filter((element) => {
        if (Array.isArray(filter)) {
          if (filter.includes('1')) {
            return element
          } else if (filter.includes(element[field].toLowerCase())) {
            return element
          }
        } else {
          if (filter === '1') {
            return element
          } else if (filter === element[field].toLowerCase()) {
            return element
          }
        }
      })
      return list
    },
    updateAlerts (vertical, type, json) {
      let alertsToday = json.today
      let alertsWeek = json.lastSevenDays
      alertsToday.forEach(element => {
        element.timestamp = this.setTimeRandom(false)
        element.timestampClose = this.setTimeRandom(false)
      })
      alertsWeek.forEach(element => {
        element.timestamp = this.setTimeRandom(true)
        element.timestampClose = this.setTimeRandom(true)
      })
      this.mapFilterAlert(alertsToday, vertical, type, 'today')
      this.mapFilterAlert(alertsWeek, vertical, type, 'week')
    },
    updateCampaigns (vertical, type, json) {
      let campaingsActive = json.active
      let campaingsInactive = json.inactive
      campaingsActive.forEach(element => {
        element.startDate = this.setTimeRandom(false)
        element.endDate = this.setTimeRandom(false)
      })
      campaingsInactive.forEach(element => {
        element.startDate = this.setTimeRandom(true)
        element.endDate = this.setTimeRandom(true)
      })
      this.mapFilterCampaigns(campaingsActive, vertical, type, 'activo')
      this.mapFilterCampaigns(campaingsInactive, vertical, type, 'inactivo')
    },
    mapFilterAlert (data, vertical, type, date) {
      if (data.length > 0) {
        data = this.mapList(data, type)
        data = this.mapFilterList(data, vertical, 'clmmodule')
      }
      switch (date) {
        case 'today':
          this.$refs.modalGenericAlerts.changeAlertToday(data)
          // this.$refs.AlertsAndCampaignsList.changeAlertToday(data)
          break
        case 'week':
          this.$refs.modalGenericAlerts.changeAlertWeek(data)
          break
      }
    },
    mapFilterCampaigns (data, vertical, type, date) {
      if (data.length > 0) {
        data = this.mapList(data, type)
        data = this.mapFilterList(data, vertical, 'clmmodule')
      }
      switch (date) {
        case 'activo':
          this.$refs.modalGenericCampaigns.changeActiveCampaigns(data)
          break
        case 'inactivo':
          this.$refs.modalGenericCampaigns.changeInactiveCampaigns(data)
          break
      }
    },

    // FUNCIONES PARA MOCKEAR
    // -- Fechas random de ultimas 24 horas y útimos 7 dias
    setTimeRandom (weekFlag) {
      const randomDate = new Date()
      const currentHour = !weekFlag ? randomDate.getDate() : 23
      let hour = 0 + Math.random() * (currentHour - 0) | 0
      let minutes = 0 + Math.random() * (60 - 0) | 0

      randomDate.setHours(hour)
      randomDate.setMinutes(minutes)
      if (weekFlag) {
        let countDay = Math.floor(Math.random() * 7) + 1
        randomDate.setDate(randomDate.getDate() - countDay)
      }

      return randomDate
    },
    // -- Genera valores aleatorios máximos y mínimos en los Kpis
    mockKpisValues (json) {
      json.forEach(item => {
        item.kpiMaxValue = Math.floor(Math.random() * (item.kpiMaxValue - item.kpiMinValue + 1)) + item.kpiMinValue
        item.kpiMinValue = Math.floor(Math.random() * (item.kpiMaxValue - item.kpiMinValue + 1)) + item.kpiMinValue
      })
      return json
    },
    // -- Para mockear valores de gráficos
    mockChartData (json, weekFlag, maxValue, minValue) {
      let count = 0
      json.forEach(item => {
        const element = item.stations.station.city.mean.hr_1
        for (let weatherItem in element) {
          element[weatherItem][0].timestamp = this.setTimeMock(weekFlag, count)
          element[weatherItem][0].value = Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue
        }
        ++count
      })
      return json
    },
    setTimeMock (weekFlag, count) {
      const mockDate = new Date()
      if (weekFlag) {
        let countDay = mockDate.getDate() - 7
        mockDate.setDate(countDay + count)
      } else {
        mockDate.setHours(count)
      }

      return mockDate
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mapElements.js